<script setup>
import { useAuthStore } from "@stores/auth";
import { useTransition } from "@vueuse/core";
import Popper from "vue3-popper";
import BaseSpinner from "@components/base/Spinner.vue";

const authStore = useAuthStore();

const cubicBezierBalance = useTransition(
  computed(() => authStore.balanceAmount() || 0),
  {
    duration: 1500,
    transition: [0.75, 0, 0.25, 1]
  }
);

const isLoadingBalance = computed(() =>
  authStore.balanceAmount() === null ||
  authStore.balanceAmount() === undefined
);

const props = defineProps({
  small: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
  <template v-if="!authStore?.activeRollover?.active">
    <BaseButton class="!border-gray-700 md:hidden" size="xs">
      <BaseSpinner v-if="isLoadingBalance" size="xs" />
      <template v-else>{{ money(cubicBezierBalance) }}</template>
    </BaseButton>

    <BaseButton class="hidden !border-gray-700 md:flex" size="sm">
      <BaseSpinner v-if="isLoadingBalance" size="sm" />
      <template v-else>{{ money(cubicBezierBalance) }}</template>
    </BaseButton>
  </template>

  <client-only v-else>
    <Popper>
      <div>
        <BaseButton class="!border-gray-700 !text-xs md:hidden" style="
          box-sizing: border-box;
          -moz-box-sizing: border-box;
          -webkit-box-sizing: border-box;
        " size="xs">
          <BaseSpinner v-if="isLoadingBalance" size="xs" />
          <template v-else>
            {{ money(cubicBezierBalance) }}
            <Icon name="fa6-solid:circle-info" size="10" class="text-white/50" />
          </template>
        </BaseButton>

        <BaseButton class="hidden border border-gray-700 !text-xs md:flex" style="
          box-sizing: border-box;
          -moz-box-sizing: border-box;
          -webkit-box-sizing: border-box;
        " size="sm">
          <BaseSpinner v-if="isLoadingBalance" size="sm" />
          <template v-else>
            {{ money(cubicBezierBalance) }}
            <Icon name="fa6-solid:circle-info" size="10" class="text-white/50" />
          </template>
        </BaseButton>
      </div>
      <template #content="{ close }">
        <transition enter-active-class="transition duration-200 ease-out" enter-from-class="translate-y-0 opacity-0"
                    enter-to-class="translate-y-4 opacity-100" leave-active-class="transition duration-150 ease-in"
                    leave-from-class="translate-y-4 opacity-100" leave-to-class="translate-y-0 opacity-0">
          <div class="w-screen flex-1 px-4 py-3 md:max-w-[380px]">
            <div class="flex flex-col space-y-6 rounded-md border border-gray-700 bg-secondary p-4">
              <RolloverBalance />

              <BaseButton @click="close" variant="secondary" size="md" to="/user/bonus">Ver bônus disponíveis
              </BaseButton>
            </div>
          </div>
        </transition>
      </template>
    </Popper>
  </client-only>
</template>